import React, { useEffect, useState } from 'react';
import { MarketplaceStyled } from '../marketplace/assets/marketplaceStyle';
import {
  useDeleteImageMutation,
  useLazyGetAllFloristImagesGalleryQuery,
  useSetFavoriteImageMutation,
} from './imagesGalleryApiSlice';
import { toast } from 'react-toastify';
import GalleryContainer from './GalleryContainer';
import useAuth from '../../hooks/useAuth';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { setShouldCallFunction } from '../../app/services/removeBackground';
import { useDispatch } from 'react-redux';
import { useUpdateImageCategoriesInBulkMutation } from '../vendors/vendorsApiSlice';

const ImagesGallery = ({
  isFlorist,
  comingFrom,
  selectedImage,
  filter,
  search,
  selectMulti,
  selectedImagesArray,
  tags,
  selectedTab,
  imageCategories = [],
  selectedCategory,
  setSelectedCategory,
  selectImages,
  setSelectedImages
}) => {
  const { user } = useAuth();
  const [images, setImages] = useState([]);
  const [initialLoading, setInitialLoading] = useState(false);
  // const [uploadImageAPI, { isLoading: loading }] = useUploadImageMutation();
  const [deleteImageAPI] = useDeleteImageMutation();
  const [setFavoriteImage] = useSetFavoriteImageMutation();
    const [updateImageCategory] = useUpdateImageCategoriesInBulkMutation();
  
  const [
    fetchImages,
    {
      data: allFloristImages,
      isLoading: isFloristLoading,
      isFetching: isFetchingFloristImages,
    },
  ] = useLazyGetAllFloristImagesGalleryQuery();
  const RemoveBackgroundData = useSelector(
    (state) => state.removeBackground ?? [],
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if(selectImages?.length === 0 || selectedCategory === null) return;
    const updateCategory = async () => {
      const payload = selectImages.map((img) => ({
        id: img.id,
        imageCategory: selectedCategory,
      }));
      const resp = await updateImageCategory(payload);
      if (!resp?.error) {
        toast.success('Image category updated successfully');
        setSelectedImages([]);
        getImages('initial');
      }
      setSelectedImages([])
    };

    updateCategory();
  }, [selectedCategory]);

  const getImages = async (fetchType) => {
    let page;
    if (fetchType === 'initial') {
      setInitialLoading(true);
      page = 0;
    } else if (fetchType === 'next') {
      page = allFloristImages
        ? (allFloristImages?.objectData?.pageable?.pageNumber ?? 0) + 1
        : 0;
    } else {
      throw new Error('Invalid fetchType');
    }

    const params = {
      page,
      size: '25',
      filter: JSON.stringify({
        ...(isFlorist === 'yourImages' ? { floristId: user?.floristId } : {}),
        ...(filter.favorite ? { favorite: true } : {}),
        ...(filter.type ? { type: filter.type } : {}),
        ...(search ? { search } : {}),
        ...(filter.category ? { category: filter.category } : {category: 80}),
        ...(filter.staticTags?.length || filter.imageTags?.length
          ? {
              tags: [
                ...(filter.staticTags ?? []),
                ...(filter.imageTags?.map((tag) => tag.id) ?? []),
              ],
            }
          : {}),
      }),
    };

    const res = await fetchImages({ params });

    if (res.data) {
      setImages((state) => {
        if (fetchType === 'initial') {
          return res.data?.objectData?.content ?? [];
        } else if (fetchType === 'next') {
          return [...state, ...(res.data?.objectData?.content ?? [])];
        }
      });
    }

    setInitialLoading(false);
  };

  const handleDelete = async (id) => {
    const resp = await deleteImageAPI(id);
    if (!resp?.error) {
      toast.success('Image deleted successfully');
      // fetchImages();
      getImages('initial');
    }
  };

  const handleFavImage = async (data, index) => {
    const payload = {
      ...data,
      floristId: user.floristId,
    };
    const resp = await setFavoriteImage(payload);
    if (!resp.error) {
      const imagesDeepCopy = structuredClone(images);
      imagesDeepCopy[index] = {
        ...imagesDeepCopy[index],
        favorite: data.favourite,
      };
      toast.success('Image updated successfully');
      setImages(imagesDeepCopy);
    }
  };

  const handleImageEditOrSave = (data, type = null) => {
    if (type === 'initial') {
      getImages('initial');
    }
    const deepCopy = structuredClone(images);
    if (data?.length === 1) {
      const image = deepCopy?.find(
        (img) => img.imageDTO?.id === data[0]?.imageDTO?.id,
      );
      if (image) {
        const index = deepCopy.findIndex(
          (img) => img.imageDTO?.id === image.imageDTO?.id,
        );
        const payload = {
          ...image,
          ...data[0],
        };
        deepCopy[index] = payload;
        setImages(deepCopy);
      } else {
        getImages('initial');
      }
    } else {
      getImages('initial');
    }
  };

  if (RemoveBackgroundData?.shouldCallFunction) {
    handleImageEditOrSave(null, 'initial');
    dispatch(setShouldCallFunction(false));
  }
  useEffect(() => {
    getImages('initial');
  }, [user, filter, search]);

  return (
    <Wrapper isFlorist={isFlorist} className={'mt-0'}>
      <div className="mb-2 mb-md-3 pb-1">
        <GalleryContainer
          isFlorist={isFlorist}
          handleDelete={handleDelete}
          // handleUpload={handleUpload}
          handleFavImage={handleFavImage}
          images={images}
          setImages={setImages}
          last={allFloristImages?.objectData?.last}
          loading={isFloristLoading || isFetchingFloristImages}
          initialLoading={initialLoading}
          comingFrom={comingFrom}
          selectedImage={selectedImage}
          handleImageEditOrSave={handleImageEditOrSave}
          fetchNext={() => getImages('next')}
          selectMulti={selectMulti}
          selectedImagesArray={selectedImagesArray}
          tags={tags}
          filter={filter}
          selectedTab={selectedTab}
          imageCategories={imageCategories}
        />
      </div>
    </Wrapper>
  );
};

const Wrapper = styled(MarketplaceStyled.PageWrap)`
  padding: 0;
`;

export default ImagesGallery;
